export const Checkbox1 = ({input_id, text, onChange, checked}) => {
    return (
        <div className="dn-checkbox-1">
            <input type="checkbox" id={input_id} className="dn-checkbox-1__input" onChange={onChange}
                   checked={checked}/>

            <span className="dn-checkbox-1__icon-wrapper">

          {/* see: https://stackoverflow.com/questions/59820954/syntaxerror-unknown-namespace-tags-are-not-supported-by-default */}
                {/* xlink:href -> xlinkHref   coz JSX...*/}
                <svg className="dn-checkbox-1__icon">
            <use xlinkHref="#icon-checkbox-check"></use>
          </svg>

        </span>

            <label htmlFor={input_id} className="dn-checkbox-1__label">{text}</label>
        </div>
    );
};

export const Radio1 = ({input_id, text, onChange, checked}) => {
    return (
        <div className="dn-checkbox-1">
            <input type="radio" id={input_id} className="dn-checkbox-1__input" onChange={onChange}
                   checked={checked}/>

            <span className="dn-checkbox-1__icon-wrapper">

          {/* see: https://stackoverflow.com/questions/59820954/syntaxerror-unknown-namespace-tags-are-not-supported-by-default */}
         {/* xlink:href -> xlinkHref   coz JSX...*/}
        <svg className="dn-checkbox-1__icon">
            <use xlinkHref="#icon-checkbox-check"></use>
          </svg>

        </span>

            <label htmlFor={input_id} className="dn-checkbox-1__label">{text}</label>
        </div>
    );
};
